import { useMemo } from "react";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { UserAvatar } from "@components/avatar/UserAvatar";
import type { ViewLabel } from "@design-system/ViewToolbar/ViewsDropdown";
import { getUserDisplayName } from "@helpers/user";
import { useUserStatus } from "@hooks/useUserStatus";

/**
 * Labels a built-in "Assigned to me" view as the signed-in user's avatar (with
 * their name on hover) and `Assigned`, for `ViewToolbar`'s `viewLabels`.
 * Empty until the user loads.
 */
export const useAssignedToMeViewLabels = (
    viewId: string,
): ReadonlyMap<string, ViewLabel> => {
    const { data: userStatus } = useUserStatus();
    const user = userStatus?.user;

    return useMemo(() => {
        if (!user) {
            return new Map();
        }
        return new Map([
            [
                viewId,
                {
                    text: "Assigned",
                    leading: (
                        <AvatarTooltip content={getUserDisplayName(user)}>
                            <UserAvatar user={user} size="xs" aria-hidden />
                        </AvatarTooltip>
                    ),
                },
            ],
        ]);
    }, [user, viewId]);
};
